/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'

import Menu from '../../../components/Menu'
import Table from '../../../components/SliderList'

import { useNavigate } from 'react-router-dom'

import foodIcon from '../../../assets/svg/offIcon.svg'
import { get } from '../../../services/http'

import { notify } from '../../../components/Toast'
import { ToastContainer } from 'react-toastify'

export default function index() {
  const [sliders, setSliders] = useState('')
  const [sliderCount, setSlidersCount] = useState()
  const [totalPage, setTotalPage] = useState()
  const [sliderStatus, setSliderStatus] = useState(false)

  const token = localStorage.getItem('token')

  const navigate = useNavigate()
  document.title = 'اسلایدر'

  const navigateHandler = () => {
    navigate('/sliders/create')
  }

  useEffect(() => {
    get(`/api/admin/sliders?token=${token}`).then(response => {
      setSliders(response.data.data.docs)
      if (response.data.data.docs.length >= 1) {
        setSliderStatus(true)
      }
      setTotalPage(response.data.data.pages)
      setSlidersCount(response.data.data.totalDocs)
    })
  }, [token])

  const handlePageClick = (event) => {
    get(`/api/admin/sliders?page=${event.selected + 1}&token=${token}`)
    .then(response => {
      setSliders(response.data.data.docs)
      setTotalPage(response.data.data.pages)
      setSlidersCount(response.data.data.totalDocs)
    }).catch(error => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'slider'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={foodIcon} alt='resturantIcon' />
              </div>
              <div className='text'>
                لیست اسلایدر
              </div>
            </div>

            <div className="left">
              <button onClick={navigateHandler} style={sliderStatus ? { display: 'none' } : { }}>ایجاد اسلایدر</button>
            </div>
          </div>

          <div className="tablePart">
            <div className="title">
              <div className="right">
                تعداد کل اسلایدها
              </div>
              <div className="left">
                {sliderCount}
              </div>
            </div>

            <Table data={sliders} />
            <ReactPaginate 
              breakLabel="..."
              nextLabel="بعدی"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={totalPage}
              previousLabel="قبلی"
              renderOnZeroPageCount={null}
            />
          </div>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
